import Space from "../../layout/Space";
import styled from "styled-components";
import { resolvePaletteRoleForegroundToken } from "../../../functions/resolvePaletteRoleForegroundToken";
import {
	StyledTypographyProps,
	TypographyVariantOptions,
} from "./Typography.types";
import { textAlign } from "styled-system";
import { Unit } from "../../../types/globals";
import { ViewportResult } from "../../../hooks/useViewport/useViewport.types";

export const getFontAndLineHeightArray = (
	variant: TypographyVariantOptions,
	vp: ViewportResult
): Unit[] => {
	switch (variant) {
		case "h1":
			return vp.lessThan.sm ? ["36px", "44px"] : ["72px", "88px"];
		case "h2":
			return vp.lessThan.sm ? ["32px", "40px"] : ["60px", "72px"];
		case "h3":
			return vp.lessThan.sm ? ["28px", "40px"] : ["48px", "60px"];
		case "h4":
			return vp.lessThan.sm ? ["24px", "36px"] : ["40px", "48px"];
		case "h5":
			return vp.lessThan.sm ? ["22px", "32px"] : ["32px", "40px"];
		case "h6":
			return vp.lessThan.sm ? ["20px", "28px"] : ["24px", "28px"];
		case "body-large":
			return ["18px", "24px"];
		case "body-small":
			return ["14px", "24px"];
		case "caption":
			return ["12px", "24px"];
		default: {
			// body
			return ["16px", "24px"];
		}
	}
};

const StyledTypography = styled(Space)<StyledTypographyProps>`
	box-sizing: border-box;
	text-overflow: ellipsis;
	font-style: ${(props) => (props.italic ? "italic" : "normal")};

	${textAlign}

	${(props) => {
		if (props.variant) {
			const palette = props.theme.palette;
			const fontAndLineHeight = getFontAndLineHeightArray(
				props.variant,
				props.viewport
			);
			return {
				fontSize: fontAndLineHeight[0],
				lineHeight: fontAndLineHeight[1],
				color: props.colorOn
					? palette.hexFor(
							resolvePaletteRoleForegroundToken(
								props.colorOn,
								props.colorContrast
							)
					  )
					: palette.hexFor(props.color) ||
					  palette.hexForRole(resolvePaletteRoleForegroundToken("bg_white")),
			};
		}
		return undefined;
	}}

	${(props) => {
		return {
			fontWeight: props.weight
				? props.theme.fontWeights.values[props.weight]
				: undefined,
		};
	}}
`;

export default StyledTypography;
